import { type ComponentProps, memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const notificationFiltersItem = tailwindVariants({
  base: 'relative flex h-10 items-center gap-2 px-2 text-12 font-semibold',
  defaultVariants: {
    state: 'default',
  },
  variants: {
    state: {
      active: 'text-grey-12',
      default: 'text-grey-11',
    },
  },
});

export const notificationFiltersItemBadge = tailwindVariants({
  base: 'flex h-4 items-center rounded-24 px-1.5 text-10 font-bold',
  defaultVariants: {
    state: 'default',
  },
  variants: {
    state: {
      active: 'bg-grey-4 text-grey-10',
      default: 'bg-grey-4 text-grey-10',
    },
  },
});

export type NotificationsFiltersItemVariants = VariantProps<typeof notificationFiltersItem>;

export type NotificationsFiltersItem = ComponentProps<'button'> &
  NotificationsFiltersItemVariants & {
    count?: number;
  };

export const NotificationsFiltersItem = memo(
  ({ children, className, count, state, ...restOfProps }: NotificationsFiltersItem) => {
    return (
      <button
        className={notificationFiltersItem({ className, state })}
        data-testid="NOTIFICATIONS_FILTERS_ITEM"
        {...restOfProps}
      >
        {children}
        {!!count && <div className={notificationFiltersItemBadge({ state })}>{count}</div>}
        {state === 'active' && <div className="absolute inset-x-2 bottom-0 h-0.5 bg-blue-9" />}
      </button>
    );
  },
);

NotificationsFiltersItem.displayName = 'NotificationsFiltersItem';
